import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  detail: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.headerTextFontSize,
    margin: "6px 0px 6px",
    textTransform: "uppercase",
  },
  label: {
    color: theme.printTableLabel,
    fontWeight: 700,
    lineHeight: "16px",
    marginRight: 8,
  },
  value: {
    color: theme.printTableLabel,
    opacity: "0.9",
    fontWeight: 600,
    lineHeight: "16px",
    marginRight: 10,
    minWidth: '30px'
  },
});
const HeaderDetails = ({ classes, label, value }) => {
  return (
    <div className={classes.detail}>
      <span className={classes.label}>{label ?? "N/A"}</span>
      <span className={classes.value}>{value ?? "N/A"}</span>
    </div>
  );
};

export default withStyles(styles)(HeaderDetails);
